<template>
  <active-button
    :fa-icon="startStopIcon"
    :text="startStopText"
    :disabled="startStopDisabled"
    :type="startStopColor"
    @click="$emit('click')"
  />
</template>

<script>
import activeButton from "@/components/active-button.vue";
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPauseCircle, faPlayCircle
} from '@fortawesome/free-solid-svg-icons';
library.add(faPauseCircle, faPlayCircle);

export default {
  name: 'start-stop-button',
  props: ['status', 'disabled'],
  components: { activeButton },
  computed: {
    startStopIcon() {
      switch (this.status) {
        case 'RUNNING':
        case 'ERROR':
        case 'STOPPING':
          return 'pause-circle';
        default:
          return 'play-circle';
      }
    },
    startStopText() {
      switch (this.status) {
        case 'RUNNING':
        case 'ERROR':
        case 'STOPPING':
          return this.$t('general.stop');
        default:
          return this.$t('general.start');
      }
    },
    startStopColor() {
      switch (this.status) {
        case 'IDLE':
          return 'success';
        case 'STARTING':
          return 'orange';
        case 'RUNNING':
          return 'danger';
        case 'ERROR':
          return 'orange';
        case 'STOPPING':
        case 'STOPPED':
          return 'orange';
        default:
          return null;
      }
    },
    startStopDisabled() {
      switch (this.status) {
        case 'STARTING':
        case 'STOPPING':
        case 'STOPPED':
          return this.disabled || true;
        default:
          return this.disabled;
      }
    },
  }
};
</script>

<style lang="scss">
.dx-button-mode-contained.dx-button-orange {
  background-color: lighten(#ff8800, 10);
  border-color: transparent;
  color: #fff;

  &.dx-state-hover,
  &.dx-state-focused,
  &.dx-state-active {
    background-color: #ff8800;
    border-color: transparent;
  }
  .dx-icon {
    color: #fff;
  }
}
</style>
